import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { projectLocationsKeys } from '../locationsKeys'
import { RequestTypes } from '../requestTypes'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useArchiveProjectLocation = (
  options?: UseMutationOptions<
    unknown,
    RequestErrorType,
    RequestTypes['archiveProjectLocation']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...projectLocationsKeys.archiveProjectLocation,
    retry: 0,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: projectLocationsKeys._def })
    },
    ...options,
  })
}
